<template>
  <transition name="fade">
    <div v-if="point" class="hover-info" :style="positionStyle">
      <div class="swatch" :style="{ backgroundColor: point.color.hex }"></div>
      <div class="text-content">
        <p class="color-name">{{ point.color.name }}</p>
        <p class="element-name">{{ point.element.name }}</p>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useMainStore } from '@/stores/mainStore';

const store = useMainStore();
const point = computed(() => store.hoveredColor);
const mousePos = ref({ x: 0, y: 0 });

const positionStyle = computed(() => ({
  left: `${mousePos.value.x + 20}px`,
  top: `${mousePos.value.y}px`,
}));

const updateMousePos = (e) => {
  mousePos.value = { x: e.clientX, y: e.clientY };
};

onMounted(() => window.addEventListener('mousemove', updateMousePos));
onUnmounted(() => window.removeEventListener('mousemove', updateMousePos));
</script>

<style scoped>
.hover-info {
  position: fixed;
  z-index: 999;
  pointer-events: none;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
  border: 1px solid #eee;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  transform: translateY(-50%);
  transition: opacity 0.2s ease;
  /* border-radius: 4px;  */
  box-shadow: 0 4px 15px rgba(0,0,0,0.1); /* 添加阴影 */
}
.swatch {
  width: 24px;
  height: 24px;
  border: 1px solid #ddd;
  flex-shrink: 0;
  /* border-radius: 3px;  */
}
.text-content p {
  margin: 0;
  white-space: nowrap;
}
.color-name {
  font-weight: 500;
  font-size: 14px;
}
.element-name {
  font-size: 12px;
  color: #666;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>